import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  OnInit,
  Input,
  DestroyRef,
  input,
  ChangeDetectionStrategy,
  computed,
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ChatStateModule } from 'libs/shared/data/stores/chat';
import { ChatActions } from 'libs/shared/data/stores/chat/chat.actions';
import { getRoomWithMembers } from 'libs/shared/data/stores/chat/chat.selectors';
import { SelectModule } from 'primeng/select';
import { switchMap } from 'rxjs';

import { ChatRoomDisplayComponent } from '@offconon/shared/features/chat/chat-room-display';
import { DesignPanelsHelperService } from '@offconon/shared/utils/services/design-panels-helper';
import { WebSocketService } from '@offconon/shared/utils/services/websocket';

@Component({
  selector: 'offconon-chat-message-header',
  imports: [
    CommonModule,
    FormsModule,
    SelectModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    ChatRoomDisplayComponent,
    ChatStateModule,
  ],
  template: `
    @if (room()) {
      <offconon-chat-room-display
        [logged_user]="logged_user()"
        [selectedBusiness]="selectedBusiness()"
        [parameters]="parameters"
        [platform]="platform"
        [room]="room()" />
    }
  `,
  styleUrls: ['chat-message-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageHeaderComponent implements OnInit {
  logged_user = input();
  selectedBusiness = input();
  @Input() parameters: any;
  @Input() platform = 'core';

  roomId = input.required<number>();
  private designPanelsHelperService = inject(DesignPanelsHelperService);
  private destroyRef = inject(DestroyRef);

  webSocketService = inject(WebSocketService);

  private store = inject(Store);

  connectionActive = toSignal(this.webSocketService.onConnectionStatus());

  activatedRoute = inject(ActivatedRoute);

  room = toSignal(
    toObservable(computed(() => this.roomId())).pipe(
      switchMap((roomId) => this.store.select(getRoomWithMembers(roomId))),
    ),
  );

  ngOnInit() {
    this.store.dispatch(
      ChatActions.fetchRooms({
        searchJson: {
          id: this.roomId(),
        },
      }),
    );

    // this.designPanelsHelperService.selectedChatRoomIdDelivery$
    //   .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe({
    //     next: (postData: any) => {
    //       if (postData !== null) {
    //         this.designPanelsHelperService.setselectedChatRoomIdDelivery(null);
    //       }
    //     },
    //   });
  }
}
